exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-d63741d6]::-webkit-input-placeholder {\n  color: #000 !important;\n}\n.app-search span[data-v-d63741d6], .form-control[data-v-d63741d6]::placeholder, .form-control[data-v-d63741d6]::-webkit-input-placeholder {\n  color: #000 !important;\n}\n", ""]);

// exports
